import React from 'react';

const PlusIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 6.5V17.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M17.5 12L6.5 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export default PlusIcon;
